/** Format seconds as m:ss for video UI. */
export function formatVideoTime(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/** Parse "m:ss" or raw seconds into seconds. */
export function parseVideoTimestamp(timestamp) {
  if (typeof timestamp === 'number') return timestamp;
  if (typeof timestamp === 'string') {
    const parts = timestamp.split(':');
    if (parts.length === 2) {
      const minutes = parseInt(parts[0], 10) || 0;
      const seconds = parseInt(parts[1], 10) || 0;
      return minutes * 60 + seconds;
    }
  }
  return 0;
}

/**
 * Playable segment for hook/CTA variations. Checks metadata object and root-level
 * fields (creator upload stores variation times on the content item directly).
 */
export function getVideoPlayableRange(currentVideo, videoDuration = 0) {
  const metadata = currentVideo?.metadata || {};
  const variationEnd = metadata.variationEndTime ?? currentVideo?.variationEndTime;
  const variationStart = metadata.variationStartTime ?? currentVideo?.variationStartTime;

  let rangeStart = 0;
  let rangeEnd = videoDuration || 0;

  if (currentVideo?.type === 'hook' && variationEnd != null && variationEnd !== '') {
    rangeStart = 0;
    rangeEnd = parseFloat(variationEnd) || videoDuration || 0;
  } else if (currentVideo?.type === 'cta' && variationStart != null && variationStart !== '') {
    rangeStart = parseFloat(variationStart) || 0;
    rangeEnd = videoDuration || 0;
  }

  return { rangeStart, rangeEnd };
}
